<template>
  <div>
    <div v-if="$apollo.queries.container.loading" class="tw-text-sm tw-text-slate-600">Loading...</div>
    <div v-else-if="container" class="tw-text-left">
      <div class="tw-mt-3 tw-border-b tw-border-slate-200">
        <nav class="tw-flex tw-flex-wrap tw-gap-2 tw-pb-3">
          <button
            type="button"
            class="tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-transition-colors"
            :class="activeTab === 'trips' ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white' : 'tw-border-slate-200 tw-bg-gray-100 tw-text-slate-700 hover:tw-bg-slate-50'"
            @click="activeTab = 'trips'"
          >
            Trips
          </button>
          <button
            v-if="shouldShowYardStatus"
            type="button"
            class="tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-transition-colors"
            :class="activeTab === 'terminal' ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white' : 'tw-border-slate-200 tw-bg-gray-100 tw-text-slate-700 hover:tw-bg-slate-50'"
            @click="activeTab = 'terminal'"
          >
            Terminal Status
          </button>
          <button
            type="button"
            class="tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-transition-colors"
            :class="activeTab === 'notes'
              ? (container?.notes?.length > 0
                ? 'tw-border-emerald-700 tw-bg-emerald-700 tw-text-white'
                : 'tw-border-slate-900 tw-bg-slate-900 tw-text-white')
              : (container?.notes?.length > 0
                ? 'tw-border-emerald-300 tw-bg-emerald-50 tw-text-emerald-700 hover:tw-bg-emerald-100'
                : 'tw-border-slate-200 tw-bg-gray-100 tw-text-slate-700 hover:tw-bg-slate-50')"
            @click="activeTab = 'notes'"
          >
            Container Notes
            <span
                v-if="container?.notes?.length > 0"
                class="tw-inline-flex tw-items-center tw-rounded-full tw-bg-emerald-600 tw-ml-2 tw-px-2.5 tw-py-1 tw-text-xs tw-font-semibold tw-text-white"
                >
                      {{ container.notes.length }}
              </span>
            
          </button>
          <button
            v-if="isReefer"
            type="button"
            class="tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-transition-colors"
            :class="activeTab === 'reefer' ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white' : 'tw-border-slate-200 tw-bg-gray-100 tw-text-slate-700 hover:tw-bg-slate-50'"
            @click="activeTab = 'reefer'"
          >
            Reefer
          </button>
          <button
            v-if="container && container.vessel && container.vessel.mssi"
            type="button"
            class="tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-transition-colors"
            :class="isVesselTrackingModalOpen ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white' : 'tw-border-slate-200 tw-bg-gray-100 tw-text-slate-700 hover:tw-bg-slate-50'"
            @click="isVesselTrackingModalOpen = !isVesselTrackingModalOpen"
          >
            Vessel Tracking
          </button>
          <button
            v-if="!showingExternally"
            type="button"
            class="tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-transition-colors"
            :class="activeTab === 'payable' ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white' : 'tw-border-slate-200 tw-bg-gray-100 tw-text-slate-700 hover:tw-bg-slate-50'"
            @click="activeTab = 'payable'"
          >
            Payable
          </button>
          <button
            v-if="!showingExternally"
            type="button"
            class="tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-transition-colors"
            :class="activeTab === 'receivable' ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white' : 'tw-border-slate-200 tw-bg-gray-100 tw-text-slate-700 hover:tw-bg-slate-50'"
            @click="activeTab = 'receivable'"
          >
            Receivable
          </button>
        </nav>
      </div>

      <div class="tw-mt-4">
        <div v-if="activeTab === 'trips'">
          <div v-if="addTripLoading" class="tw-flex tw-justify-center tw-py-10">
            <div class="tw-h-8 tw-w-8 tw-animate-spin tw-rounded-full tw-border-2 tw-border-slate-300 tw-border-t-slate-600"></div>
          </div>
          <ContainerTripsTable
            v-else
            caller="orders"
            :showDriver="showDriver"
            :editable="editable && !container.isCancelled"
            :key="container.id"
            :order="order"
            :container="container"
            :trips="container.trips"
            :drivers="drivers"
            :chassis="chassis"
            @refreshOrders="refreshOrders"
          />
        </div>

        <div v-else-if="activeTab === 'terminal' && shouldShowYardStatus">
          <ContainerTerminalEventsTable v-if="containerEvents" :containerEvents="containerEvents" :terminal="container.dischargeTerminal" />
        </div>

        <div v-else-if="activeTab === 'notes'">
          <AddNotesArea @addedNote="updateContainer" :notes="container.notes" :archivedNotes="container.archivedNotes" :container="container"></AddNotesArea>
        </div>

        <div v-else-if="activeTab === 'reefer' && isReefer">
          <ContainerReeferDetails :container="container" :editable="editable && !container.isCancelled" />
        </div>


        <div v-else-if="activeTab === 'payable' && !showingExternally">
          <ContainerPayableArea :container="container" />
        </div>

        <div v-else-if="activeTab === 'receivable' && !showingExternally">
          <ContainerReceivableArea :containerId="container.id" />
        </div>
      </div>
    </div>
    <Modal v-model:isOpen="isVesselTrackingModalOpen" :modalId="`vessel-tracking-${container.containerId}`" maxWidth="4xl" v-if="container && container.vessel && container.vessel.mssi">
      <template #title>Vessel Tracking: {{ container.vessel.name }} ({{ container.vessel.mssi }})</template>
      <template #subtitle></template>  
      <template #content>
        <VesselFinderEmbed :mssi="container.vessel.mssi" height="500" :isShowTitle="false" />
      </template>
    </Modal>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ContainerTerminalEventsTable from '@/components/ContainerTracker/Terminal/ContainerTerminalEventsTable.vue';
import OrderContainerQuery from '@/gql/orders/queries/OrderContainer.gql';
import ContainerEventsQuery from '@/gql/containers/query/ContainerEvents.gql';

import ContainerTripsTable from '../ContainerTripsTable.vue';
import VesselFinderEmbed from '@/components/ContainerTracker/Vessel/VesselFinderEmbed.vue';
import ContainerPayableArea from './ContainerPayableArea.vue';
import ContainerReceivableArea from './ContainerReceivableArea.vue';
import CopyButton from '../../core/CopyButton.vue';
import Modal from '@/components/core/Modal/Modal.vue';
import ContainerReeferDetails from '@/components/Container/ContainerReeferDetails.vue';
import { getIsReeferSizeType } from '@/utils/container';

export default defineComponent({
  props: {
    chassis: {
      type: Array,
    },
    drivers: {
      type: Array,
    },
    containerId: {
      required: true,
    },
    order: {
      required: true,
    },
    editable: {
      default: true,
    },
    showDriver: {
      default: true,
    },
    addTripLoading: {
      default: false,
    },
    showingExternally: {
      default: true,
    },
  },
  components: {
    ContainerTripsTable,
    ContainerTerminalEventsTable,
    ContainerPayableArea,
    ContainerReceivableArea,
    CopyButton,
    VesselFinderEmbed,
    Modal,
    ContainerReeferDetails,
  },
  computed: {
    isReefer(): boolean {
      return getIsReeferSizeType(((this as any).container as any)?.sizeType);
    },
    shouldShowYardStatus(): boolean {
      return ((this as any).order as any).orderType === 'Import';
    },
  },
  data() {
    return {
      container: undefined,
      containerEvents: undefined,
      activeTab: 'trips',
      isVesselTrackingModalOpen: false
    };
  },
  methods: {
    refreshOrders() {
      const vm = (this as any);;
      vm.$emit('refreshOrder');
      vm.$apollo.queries.container.refetch();
    },
    updateContainer() {
      (this as any).$apollo.queries.container.refetch();
    },
  },
  apollo: {
    container: {
      query: OrderContainerQuery,
      skip() {
        return (this as any).containerId === -1;
      },
      variables() {
        return {
          id: (this as any).containerId,
          notes: true,
        };
      },
    },
    containerEvents: {
      query: ContainerEventsQuery,
      variables() {
        return {
          id: (this as any).containerId,
        };
      },
      skip() {
        return (this as any).containerId === -1;
      },
    },
  },
});
</script>